// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"177":"6b90b298","282":"f668567f","443":"0d6cce2a"}[chunkId] + ".js";
};